import React from 'react';
import { Section, SectionTitle } from '../Section';
import { TESTIMONIALS } from '../../data/landing';
export function TestimonialsSection() {
  return <Section tone="ink" wide={TESTIMONIALS.length > 0} data-id="element-97" data-mp="1wn6314zync82">
      <SectionTitle className="text-center" data-id="element-98" data-mp="1ruw81ajznlyx">+ 200 personas ya lo tomaron.</SectionTitle>
      {TESTIMONIALS.length > 0 && <ul className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-99" data-mp="1mvtfuqp3xa8d">
          {TESTIMONIALS.map(t => <li key={`${t.name}-${t.quote}`} className="flex flex-col rounded-2xl border border-gold/40 bg-wine/40 p-6" data-id="element-100" data-mp="1iv9fle98lqi0">
              <p className="font-serif text-[1.4rem] italic leading-snug text-ivory" data-id="element-101" data-mp="1dv3i3hgad9s0">"{t.quote}"</p>
              <p className="mt-auto pt-5 text-sm text-gold" data-id="element-102" data-mp="18xbuv0ql6bu5">
                {t.name} · {t.country}
              </p>
            </li>)}
        </ul>}
    </Section>;
}